import { render, staticRenderFns } from "./UpdateForm2.vue?vue&type=template&id=7f69eb0b"
import script from "./UpdateForm2.vue?vue&type=script&lang=js"
export * from "./UpdateForm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports